import { DEVELOPMENT_ENV, STAGING_ENV } from "./common";

/**
 * The only `VITE_ENV` values the Marker.io widget loads in. An allow-list rather
 * than a "not production" check: prod builds with `VITE_ENV=prod`, which slipped
 * past the old `!== "production"` test, and a missing or unexpected value must
 * leave the widget off (MDRS-557).
 */
export const MARKER_ENABLED_ENVS: readonly string[] = [DEVELOPMENT_ENV, STAGING_ENV];

/** Marker.io replaces text inside this element with placeholders in captures. */
export const MARKER_MASK_CLASS = "mk-mask";

/**
 * Marker.io leaves this element and everything in it out of captures. For
 * document previews, whose canvas and images text masking cannot reach.
 */
export const MARKER_EXCLUDE_CLASS = "mk-exclude";
